import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
      
      // Clear all auth data
      document.cookie = 'session_token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      localStorage.removeItem('session_token');
      localStorage.removeItem('user');
      
      toast.success('Logged out successfully');
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      
      // Still clear local data even if API call fails
      localStorage.removeItem('session_token');
      localStorage.removeItem('user');
      
      toast.error('Logout failed');
    }
  };

  return (
    <nav className="border-b border-card-border bg-card/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16">
          <Link to="/dashboard" className="font-heading font-black text-xl">
            Real<span className="text-primary">Flation</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <NavLink to="/dashboard">Dashboard</NavLink>
            <NavLink to="/expenses">Expenses</NavLink>
            <NavLink to="/insights">Insights</NavLink>
            <NavLink to="/settings">Settings</NavLink>
            <Button 
              onClick={handleLogout}
              variant="outline" 
              size="sm"
              className="ml-4 border-card-border hover:border-destructive hover:text-destructive"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>

          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <MobileNavLink to="/dashboard" onClick={() => setIsOpen(false)}>Dashboard</MobileNavLink>
            <MobileNavLink to="/expenses" onClick={() => setIsOpen(false)}>Expenses</MobileNavLink>
            <MobileNavLink to="/insights" onClick={() => setIsOpen(false)}>Insights</MobileNavLink>
            <MobileNavLink to="/settings" onClick={() => setIsOpen(false)}>Settings</MobileNavLink>
            <Button 
              onClick={handleLogout}
              variant="outline" 
              size="sm"
              className="w-full border-card-border hover:border-destructive hover:text-destructive"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

const NavLink = ({ to, children }) => {
  return (
    <Link
      to={to}
      className="text-muted-foreground hover:text-foreground transition-colors font-medium"
    >
      {children}
    </Link>
  );
};

const MobileNavLink = ({ to, children, onClick }) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className="block py-2 text-muted-foreground hover:text-foreground transition-colors"
    >
      {children}
    </Link>
  );
};

export default Navigation;
